module.exports = __webpack_public_path__ + "static/media/iconRefresh.dd05f369.svg";